module.exports = __webpack_public_path__ + "static/img/analysis1.699b939.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/analysis1.png
// module id = f0Oi
// module chunks = 1